import { ChangeDetectionStrategy, Component, booleanAttribute, inject, input } from '@angular/core';

import { SvgIconComponent } from '@dmb/core';

import { CoBrandingService } from '../../services';

@Component({
  selector: 'dmb-brand-logo',
  imports: [SvgIconComponent],
  templateUrl: './brand-logo.component.html',
  styleUrl: './brand-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandLogoComponent {
  private coBrandService = inject(CoBrandingService);

  /** show the "digital media base" title below the logo */
  hideTitle = input(false, { transform: booleanAttribute });

  logo = this.coBrandService.loginLogo;
  coBrand = this.coBrandService.coBrand;
}
